<div class="container container-fluid center-content p-xs-1  p-sm-0 cmspage" ifSettingTrue="Global_CMS_Enabled">
  <div class="row">
    <div class="col-12 mb-3 pl-sm-0 pl-3">
      <mat-card appearance="outlined" class="mt-2 mat-card p-4">
        <mat-card-content class="ml-1 pl-md-4">
          <h1 class="page-title mb-4 mt-3">
            Sitefinity Data
          </h1>
          <div>
            <mat-checkbox type="checkbox" id='HideParents' [(ngModel)]="HideParents">
              <span>Hide Parent Records</span>
            </mat-checkbox>
            <button
            ifSettingTrue="Global_AllowContentAuthoring"
            (click)="toggleDeveloperMode()" class="btn btn-primary ms-5" style="height: 35px;">
            <span *ngIf="resourceService.isEditMode">Dev Off </span>
            <span *ngIf="!resourceService.isEditMode">Dev On </span>
          </button>
          <br />  <br />
          <span class="fs-6">Filter By Title : </span><input matInput [(ngModel)]="filterBy" />
          </div>
          <br />
          <mat-tab-group>
            <mat-tab label="Content">
              <br />
              <div class="m-2 mt-3" >
              <div class="mb-3">
               <button class="btn  btn-primary download-button" (click)="downloadContent()">Download</button></div>
              <table>
                <tr class="bold">
                  <td>Title</td>
                    <td>Value</td>
                  </tr>
                <tr *ngFor="let item of labelArray"  >
                  <ng-container *ngIf="filterBy=='' || item.ResourceKey.toLowerCase().indexOf(filterBy.toLowerCase())>-1">
                    <td *ngIf="!(HideParents && item.S ==='P')">{{ item.ResourceKey }}</td>
                    <td *ngIf="!(HideParents && item.S ==='P')"><adp-label [labelKey]="item.ResourceKey"></adp-label></td>
                  </ng-container>
                  </tr>
               </table>
              </div>
            </mat-tab>
            <mat-tab label="Form Resources">
              <form class="p-0 col-md-6 col-sm-6" [formGroup]="form" id="verify-form">
              <br />
              <div class="m-2 mt-3">
                <div class="mb-3"><button class="btn  btn-primary download-button" (click)="downloadResource()">Download</button></div>
              <table>
                <tr class="bold" >
                  <td>Title</td>
                  <td>Preview</td>
                  <td>ValidationMessage</td>
                  <td>Hint</td>
                  <td>Tooltip</td>
                  </tr>
                <tr *ngFor="let item of formResourceArray"  >
                  <ng-container *ngIf="filterBy=='' || item.Title.toLowerCase().indexOf(filterBy.toLowerCase())>-1">

                    <td *ngIf="!(HideParents && item.S ==='P')">{{ item.Title  }}
                    </td>
                    <td *ngIf="!(HideParents && item.S ==='P')">
                      <adp-input [resourceData]="getResourceObject(item.Title)"
                      formControlName="Test" ></adp-input>
                    </td>
                    <td *ngIf="!(HideParents && item.S ==='P')">{{ item.ValidationMessage }}</td>
                    <td *ngIf="!(HideParents && item.S ==='P')">{{ item.Hint }}</td>
                    <td *ngIf="!(HideParents && item.S ==='P')">{{ item.ToolTip }}</td>
                    </ng-container>
                </tr>
                </table>
              </div>
              </form>
            </mat-tab>
            <mat-tab label="Settings">
              <br />
              <div class="m-2 mt-3" >
              <div class="mb-3">
              </div>
              <table>
                <tr class="bold">
                <td>Title</td>
                  <td>Value</td>
                </tr>
                <tr *ngFor="let item of settingsArray" >
                  <ng-container *ngIf="filterBy=='' || item.Title.toLowerCase().indexOf(filterBy.toLowerCase())>-1">

                  <td *ngIf="!(HideParents && item.S ==='P')">
                    <div *ngIf="resourceService.isEditMode">
                      <adp-setting [key]="item.Title"></adp-setting>
                    </div>
                    <div *ngIf="!resourceService.isEditMode">
                      {{ item.Title }}
                    </div>


                  </td>
                  <td *ngIf="!(HideParents && item.S ==='P')">{{ item.Value }} </td>
                  </ng-container>
                  </tr>
               </table>
              </div>
            </mat-tab>
            <mat-tab label="Clone">
              <div class="m-2 mt-3" *ngIf="!configService.isProduction" ifSettingTrue="Global_Cloning_Enabled" >

                  <adp-banner [innerHTML]="result" messageType="success" *ngIf="result"></adp-banner>
                  <adp-banner [innerHTML]="error" messageType="blocked"  *ngIf="error"></adp-banner>
                  <br />

                <div class="mb-3">
                  Clone Data
                </div>
                <div>
                  <form [formGroup]="cloneForm">
                    <adp-input class="w-100" [resourceData]="getResourceObject('CMS_TargetSitefinityId')"
                    formControlName="TargetSitefinityId"></adp-input>


                    <adp-input class="w-100" [resourceData]="getResourceObject('CMS_TargetSitefinityLanguages')"
                    formControlName="TargetSitefinityLanguages"></adp-input>

                    <span>You must specify all the languages you want to copy for example: en,es-419 </span>
                  </form>
                </div>
                <br />
                  <button class="btn btn-primary ms-3 clone-btn" [disabled]="isEnglish && !cloneForm.valid" (click)="cloneSettings()">Clone Settings </button>
                  <button class="btn btn-primary ms-3 clone-btn"  [disabled]="!cloneForm.valid" (click)="cloneContent()">Clone Content </button>
                  <button class="btn btn-primary ms-3 clone-btn"  [disabled]="!cloneForm.valid" (click)="cloneResources()">Clone Resources </button>
                  <br />
                  <br />
                  <button class="btn btn-primary ms-3 clone-btn"  [disabled]="!cloneForm.valid" (click)="cloneLists()">Clone Lists </button>
                  <button class="btn btn-primary ms-3 clone-btn"  [disabled]="!cloneForm.valid" (click)="cloneImages()">Clone Images </button>
                  <button class="btn btn-primary ms-3 clone-btn"  [disabled]="!cloneForm.valid" (click)="cloneMenus()">Clone Menus </button>


                <br /> <br />

              </div>
            </mat-tab>
          </mat-tab-group>


          <!-- <div>


          </div> -->

          <div>

          </div>

        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
